import { Injectable } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unknown error occurred';
      let validationErrors: string[] = [];

      // Check if it's a client-side error (browser error)
      if (
        error.error &&
        typeof error.error === 'object' &&
        'message' in error.error &&
        typeof error.error.message === 'string'
      ) {
        // Client-side error
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Server-side error
        if (error.error?.message) {
          errorMessage = error.error.message;
        } else if (typeof error.error === 'string' && error.error) {
          errorMessage = error.error;
        } else if (error.error?.errors) {
          // Handle validation errors format
          const errors = error.error.errors;
          validationErrors = [];

          // Extract all validation error messages
          for (const key in errors) {
            if (Object.prototype.hasOwnProperty.call(errors, key)) {
              if (Array.isArray(errors[key])) {
                validationErrors.push(...errors[key]);
              } else {
                validationErrors.push(`${key}: ${errors[key]}`);
              }
            }
          }

          if (validationErrors.length > 0) {
            errorMessage = 'Validation Errors';
          } else {
            errorMessage = `Error Code: ${error.status}, Message: ${error.message}`;
          }
        } else {
          errorMessage = `Error Code: ${error.status}, Message: ${error.message}`;
        }
      }

      console.error('API Error Intercepted:', {
        originalError: error,
        processedMessage: errorMessage,
        validationErrors:
          validationErrors.length > 0 ? validationErrors : undefined,
      });

      // Re-throw the original HttpErrorResponse so component handlers can process it
      return throwError(() => error);
    }),
  );
